<template>
  <el-col align="left">
    <popup
      button-style="primary"
      heading="New Site Contractor Statement"
      :show-text="showText"
      button-text="Site Cont."
      :center-button="true"
      :button-size="buttonSize"
      :disable-button="!isManager('project|maintenance|management|finance')"
      button-icon="fa fa-plus"
      @save="onSaveDialog"
      @close="onCloseDialog">

        <site-contractors-details
           ref="scd"
           :row-data="siteContData"
           :editMode="editMode"
           :adding="true"
           hide-panel
           :site-id="siteId"
           :table-ref="tableRef" />

    </popup>
  </el-col>

</template>


<script>

import SiteContractorsDetails from '@/components/sites/finance/contractors/SiteContractorsDetails'

export default {

  components: {
    SiteContractorsDetails
  },

  props: {

    siteId: {
      type: Number,
      required: true
    },

    showText: {
      type: Boolean,
      default: true
    },

    editMode: {
      type: Boolean,
      default: true
    },

    buttonSize: {
      type: String,
      default: 'small'
    },


    tableRef: {
      type: String,
      default: 'site-contractors-table'
    }

  },

  methods: {

    onSaveDialog () {
      this.siteContData.site_id = this.siteId
      this.$refs.scd.onSave()
    },

    onCloseDialog () {
      this.$refs.scd.onClose()
    }

  },

  data () {
    return {
      siteContData: this.getTableStruct('site_contractors')
    }
  },

}

</script>
